




// @ is an alias to /src
import { Component, Vue, Watch } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import BasePlat from '@/components/carte/BasePlat'


@Component({
  name: 'ProduitMultiplesQuantifiable'  
})
export default class ProduitMultiplesQuantifiable extends mixins(BasePlat) {   
  dense!:boolean
}
